export { ColorPalette as default } from './ColorPalette';
